/**
 * RewardsPolicyPage
 *
 * Static public page displaying the Rewards Policy.
 * Accessible without authentication.
 */
import { useLocale } from '@/presentation/contexts/LocaleContext';
import { LegalDocumentPage } from './LegalDocumentPage';
import rewardsPolicyHtml from './content/rewardsPolicy.html?raw';

export const RewardsPolicyPage = () => {
  const { l10n } = useLocale();
  return <LegalDocumentPage qaId="legal-rewards-policy" title={l10n.legal.rewardsPolicy} htmlContent={rewardsPolicyHtml} />;
};
